/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_End_Auto_Deliver_NoticeInputs */

const vi_trip_end_auto_deliver_notice = /** @type {(inputs: Trip_End_Auto_Deliver_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn đang giao sẽ được tự động đánh dấu đã giao khi kết thúc chuyến`)
};

/**

* @param {Trip_End_Auto_Deliver_NoticeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_end_auto_deliver_notice = /** @type {((inputs?: Trip_End_Auto_Deliver_NoticeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_End_Auto_Deliver_NoticeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_end_auto_deliver_notice(inputs)
});